export default __webpack_public_path__ + "static/media/home-icon-active.36be6a78.webp";